import { useTranslation } from 'react-i18next'
import { Box, Drawer, IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'

import { DrawersEnum } from '@/enums/ui/drawer.enum'
import useUIFeedback from './hooks/use-ui-feedback'
import ProfileDetails from './profile-details/index.component'

import TwoFactorComponent from './two-factor-authentication/index.component'

const EditProfileDrawer = () => {
  const { drawer, handleOnCloseDrawer } = useUIFeedback()

  const { t } = useTranslation()

  return (
    <Drawer
      anchor="right"
      open={drawer.open && drawer.id === DrawersEnum.DRAWER_EDIT_PROFILE}
      onClose={handleOnCloseDrawer}
    >
      <Box width="100vw" maxWidth={700} p={4} overflow="auto">
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h5">{t('sidebar.editProfile')}</Typography>
          <IconButton aria-label="close" onClick={handleOnCloseDrawer}>
            <Close />
          </IconButton>
        </Box>
        <ProfileDetails />
        <TwoFactorComponent />
      </Box>
    </Drawer>
  )
}

export default EditProfileDrawer
